module.exports = __webpack_public_path__ + "img/loginimg.aeb8a8e7.png";